import { useEffect, useRef } from 'react';
import { useLicitacionesStore } from '../store/licitacionesStore';
import { useComprasAgilesStore } from '../store/comprasAgilesStore';
import { useNotificationsStore } from '../store/notificationsStore';
import { useLoadingStore } from '../store/loadingStore';
import { useAuthReady } from './useAuthReady';

export const useDataPolling = () => {
  const isAuthReady = useAuthReady();
  const { fetchLicitaciones } = useLicitacionesStore();
  const { fetchComprasAgiles } = useComprasAgilesStore();
  const { fetchNotifications } = useNotificationsStore();
  const { setPolling } = useLoadingStore();
  const isFirstLoadRef = useRef(true);

  useEffect(() => {
    if (!isAuthReady) return;

    const updateData = async () => {
      const isFirstLoad = isFirstLoadRef.current;
      
      const licitacionesState = useLicitacionesStore.getState();
      const comprasAgilesState = useComprasAgilesStore.getState();
      
      try {
        if (!isFirstLoad) {
          setPolling(true);
        }
        await Promise.all([
          fetchLicitaciones({ 
            silent: !isFirstLoad, 
            page: licitacionesState.page, 
            limit: licitacionesState.limit 
          }),
          fetchComprasAgiles({ 
            silent: !isFirstLoad, 
            page: comprasAgilesState.page, 
            limit: comprasAgilesState.limit 
          }),
          fetchNotifications({ silent: !isFirstLoad })
        ]);
        if (isFirstLoad) {
          isFirstLoadRef.current = false;
        }
      } catch (error) {
        console.error('Error en el polling de datos:', error);
      } finally {
        if (!isFirstLoad) {
          setPolling(false);
        }
      }
    };

    updateData();

    const pollingInterval = parseInt(process.env.REACT_APP_POLLING_INTERVAL_MS || '180000', 10);
    const intervalId = setInterval(updateData, pollingInterval);

    return () => clearInterval(intervalId);
  }, [isAuthReady, fetchLicitaciones, fetchComprasAgiles, fetchNotifications, setPolling]);
}; 